module.exports = __webpack_public_path__ + "static/media/embs_noir.f9f518b3.png";